var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgMission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 648 423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cd62c5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_AboutUs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.49,43.26c27.43-2.61,27.91-8.93,54.14-10.6,31.16-2,56.42,3.31,74.51,28.76,14.07,19.79,12.82,46.46,8.58,70.38s-10.87,48.4-5.6,72.12c6.39,28.77,29.91,54.78,24.32,83.71-4,20.86-22.67,36-42.29,44.18-46,19.13-99.66,8.52-144.49-13.31s-83.69-54-125.82-80.67-90.16-48.41-139.94-45.4C159.46,194.32,129.35,206,98,209.35s-67.31-4.25-84.11-30.89C3.63,162.12,2.5,141.73,3,122.42c.46-17,2-34.36,8.37-50.19C27.2,32.7,70.34,9.67,112.66,5s84.64,5.71,126.18,15c68.66,15.42,138.8,28.31,209,23.8C447.88,43.87,475.77,44.38,487.49,43.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.28,358.71a11.41,11.41,0,0,0-7.06,6.13,29.44,29.44,0,0,0-2.16,10.81c-.53,13.06,3.81,25.52,9.53,32.55s12.61,9.47,19.36,10.7a53.68,53.68,0,0,0,28.31-2.1,11,11,0,0,0,7-6c1.55-3.35,2.05-8.1,2-12.59-.3-15.64-7-28.65-14.56-34.23S596.78,353.78,583.28,358.71Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMission);
export default __webpack_public_path__ + "static/media/bg_mission.80386d286dbf0ffe3af0549d833bcdd7.svg";
export { ForwardRef as ReactComponent };